/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — MIT white-label additions
 * to Chatwoot Community Edition. Not derived from the commercial code under enterprise/.
 */
import ApiClient from './ApiClient';

class BotDocumentsAPI extends ApiClient {
  constructor() {
    super('bot_documents', { accountScoped: true });
  }
}

export default new BotDocumentsAPI();
